<!-- Selected -->
<div
  *ngIf="value && !isSearching; else search"
  class="flex items-center justify-between gap-3 rounded-lg border border-gray-200 px-3 py-2"
>
  <div class="flex items-center gap-3 overflow-hidden">
    <vs-icon name="tool-02" class="text-gray-500 shrink-0"></vs-icon>
    <div class="overflow-hidden">
      <p class="text-sm font-medium text-gray-900 truncate">{{ value.name }}</p>
      <p class="text-xs text-gray-500 truncate">
        {{ describe(value) }}
      </p>
    </div>
  </div>

  <div *ngIf="!disabled" class="flex gap-1 shrink-0">
    <button vs-button size="sm" appearance="clear" type="button" (click)="isSearching = true">Change</button>
    <button vs-icon-button size="sm" appearance="clear" type="button" (click)="select(null)">
      <vs-icon name="x-close"></vs-icon>
    </button>
  </div>
</div>

<!-- Search -->
<ng-template #search>
  <div class="flex flex-col gap-2">
    <vs-input-container>
      <vs-icon name="search-lg" slot="start"></vs-icon>
      <input
        #searchInput
        vsInput
        placeholder="Search by name, phone, email or tax ID"
        [disabled]="disabled"
        (focus)="isListOpen = true"
        (blur)="isListOpen = false"
        (input)="searchInput$.next(searchInput.value)"
      />
    </vs-input-container>

    <!-- Open only while the search is focused; mousedown keeps focus so a result can be clicked -->
    <ng-container *ngIf="isListOpen">
      <ul
        *vsLet="results$ | async as results"
        class="flex flex-col rounded-lg border border-gray-200 divide-y divide-gray-100 max-h-56 overflow-y-auto"
        (mousedown)="$event.preventDefault()"
      >
        <li *ngIf="results === null" class="px-3 py-2 text-sm italic text-gray-500">Searching…</li>
        <li *ngIf="results?.length === 0" class="px-3 py-2 text-sm text-gray-500">
          No active service providers found.
        </li>

        <li *ngFor="let provider of results">
          <button type="button" class="w-full text-left px-3 py-2 hover:bg-gray-50" (click)="select(provider)">
            <p class="text-sm font-medium text-gray-900 truncate">{{ provider.name }}</p>
            <p class="text-xs text-gray-500 truncate">{{ describe(provider) }}</p>
          </button>
        </li>
      </ul>
    </ng-container>

    <button
      *ngIf="value"
      vs-button
      size="sm"
      appearance="clear"
      type="button"
      class="self-end"
      (click)="isSearching = false; isListOpen = false"
    >
      Keep {{ value.name }}
    </button>
  </div>
</ng-template>
